export enum PaymentType{
    BANK_TRANSFER = 'Bankovní převod',
    PROFORMA = 'Dobírka',
}
